module.exports = __webpack_public_path__ + "static/media/uv3.bf2fa598.jpg";